
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, RotateCcw } from 'lucide-react';
import { type CandidateResponseStatus } from '@/services/campaignService';

interface RefusalConfirmationStateProps {
  candidateStatus: CandidateResponseStatus;
  onChangeDecision: () => Promise<void>;
}

export const RefusalConfirmationState = ({ candidateStatus, onChangeDecision }: RefusalConfirmationStateProps) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center space-y-6">
          <XCircle className="h-16 w-16 text-red-500 mx-auto" />
          
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Refus enregistré</h2>
            <p className="text-gray-600 mb-4">
              Votre refus de participer a été enregistré et le recruteur en a été informé.
            </p>
            
            {candidateStatus.refusal_reason && (
              <div className="bg-gray-50 p-3 rounded text-sm text-gray-700">
                <strong>Motif :</strong> {candidateStatus.refusal_reason}
              </div>
            )}
          </div>

          <div className="pt-4">
            <p className="text-sm text-gray-500 mb-4">
              Vous avez changé d'avis ? Vous pouvez encore participer à cette prise de référence.
            </p>
            
            <Button 
              onClick={onChangeDecision}
              variant="outline"
              className="w-full"
            >
              <RotateCcw className="h-4 w-4 mr-2" />
              Changer d'avis et participer
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
